import { TradeRoute as ServerTradeRoute } from 'server/models/TradeRoute';

export * from 'server/models/TradeRoute';

export class TradeRoute extends ServerTradeRoute {
    /** A comparator function for TradeRoutes. */
    static DisplayOrder(r1 : TradeRoute, r2 : TradeRoute) {
        let cmp : number;
        return (cmp = r1.DisplayOrder() - r2.DisplayOrder()) === 0 ?
            // If DisplayOrder matches, fallback to Id for a deterministic sort.
            r1.Id() - r2.Id() :
            cmp;
    }
}



// WEBPACK FOOTER //
// ./data/models/TradeRoute.ts